import PropTypes from 'prop-types';

const Url = {
  value: PropTypes.string,
  iconState: PropTypes.string
};

export default Url;
